
import { defineComponent, PropType } from 'vue'
import ResetArrowIcon from '@/assets/vuetifyIcons/resetArrow.vue'
import { AudienceSettingsSchemaItem } from '../../../../../types/GCB2'

export default defineComponent({
    name: 'AudienceSchemaBlockCard',
    components: { ResetArrowIcon },
    props: {
        item: { type: Object as PropType<AudienceSettingsSchemaItem>, required: true },
        open: { type: Boolean, default: false },
    },
})
